// src/constants/gameModules.js
import React from 'react';

export const GAME_MODULES = [
    {
      id: 'wintermere',
      name: 'Frost and Bones: The Ruins of Castle Wintermere',
      description: 'Embark on a chilling adventure in a frost-covered land.',
      minPlayers: 1,
      maxPlayers: 1,
      recommendedPlayers: 1,
      minLevel: 1,
      maxLevel: 1,
      maxPartySize: 1,
      thumbnail: (
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <rect width="100" height="100" fill="#87CEEB"/>
          <polygon points="50,10 10,90 90,90" fill="#FFFFFF"/>
          <circle cx="50" cy="50" r="10" fill="#1E90FF"/>
        </svg>
      ),
      difficulty: 'Beginner',
      estimatedDuration: '2-3 hours',
      tags: ['Single Player', 'Story Rich', 'Fantasy'],
      status: 'PUBLISHED'
    },
    {
      id: 'darkforest',
      name: 'The Dark Forest',
      description: 'Journey through an ancient, mysterious forest filled with danger and magical secrets.',
      minPlayers: 1,
      maxPlayers: 1,
      recommendedPlayers: 1,
      minLevel: 1,
      maxLevel: 5,
      maxPartySize: 1,
      thumbnail: (
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <rect width="100" height="100" fill="#1f2937"/>
          <path d="M30,90 L40,40 L50,90 L60,40 L70,90" fill="#2d3748" stroke="#4b5563" strokeWidth="2"/>
          <path d="M20,90 L30,50 L40,90 L50,50 L60,90 L70,50 L80,90" fill="#1e3a8a" stroke="#3b82f6" strokeWidth="2"/>
          <circle cx="60" cy="30" r="10" fill="#f59e0b" fillOpacity="0.7"/>
          <path d="M20,90 C30,70 70,70 80,90" fill="none" stroke="#6b7280" strokeWidth="1"/>
        </svg>
      ),
      difficulty: 'Intermediate',
      estimatedDuration: '4-6 hours',
      tags: ['Single Player', 'Skill Checks', 'Fantasy', 'Exploration'],
      status: 'PUBLISHED'
    }
    // Add more games here as they become available
  ];